export default {
    api: {
        url: 'https://api-portal-tfg-staging.azurewebsites.net/api/v1',
    },
    uploadApi: {
        url: 'https://taycor-doc-upload-staging.azurewebsites.net/api/v1',
    },
};
